// extracted by mini-css-extract-plugin
export default {"title":"_66f171a3","listWrapper":"_fa9c9cd2"};